import { render, staticRenderFns } from "./job-offer.vue?vue&type=template&id=89822042&scoped=true&"
import script from "./job-offer.vue?vue&type=script&lang=js&"
export * from "./job-offer.vue?vue&type=script&lang=js&"
import style0 from "./job-offer.vue?vue&type=style&index=0&id=89822042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89822042",
  null
  
)

export default component.exports